<template>
  <div
    class="bg-cool-gray-50 py-4 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-12"
  >
    <div class="relative max-w-xl mx-auto">
      <div class="mb-4">
        <img
          class="object-cover object-center rounded justify-center mx-auto w-48 mb-4"
          alt="hero"
          src=".././assets/ccme-logo.png"
        />
        <h3
          class="text-xl leading-9 tracking-tight font-bold text-primary-900 sm:text-3xl sm:leading-10 text-center"
        >
          الاستفسار عن ناخبين مسجلين
        </h3>
      </div>

      <div class="pt-8 border-t-2 border-gray-300 mt-10">
        <ValidationObserver
          v-slot="{ handleSubmit, errors, invalid, failed }"
          v-if="!success"
        >
          <form
            @submit.prevent="handleSubmit(send)"
            class="grid grid-cols-1 row-gap-6 sm:grid-cols-4 sm:col-gap-8 text-right"
          >
            <div class="sm:col-span-4">
              <label
                for="nid"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الرقم الانتخابي</label
              >

              <ValidationProvider
                name="nid"
                rules="required"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    id="nid"
                    v-model="info.nid"
                    type="number"
                    class="form-input py-3 px-4 block w-full transition te ease-in-out duration-150 text-center"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                  v-html="v.errors[0]"
                ></p>
              </ValidationProvider>
            </div>

            <div
              class="sm:col-span-4 mt-2"
              v-if="(invalid && failed) || servererrors != null"
            >
              <div class="rounded-md bg-red-50 p-4">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <!-- Heroicon name: x-circle -->
                    <svg
                      class="h-5 w-5 text-red-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div class="mr-3">
                    <h3 class="text-base leading-5 font-medium text-red-500">
                      هناك أخطاء في إدخالك للحقول يجب معالجتها قبل الاستمرار
                    </h3>
                    <div
                      class="mt-2 text-base leading-5 text-red-700"
                      v-if="servererrors != null"
                    >
                      <ul class="list-disc pr-5">
                        <li class="mt-1">
                          {{ servererrors }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="sm:col-span-4 mt-1">
              <span class="w-full inline-flex rounded-md shadow-sm">
                <button
                  type="submit"
                  class="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-lg leading-6 font-bold rounded-md text-white bg-primary-500 hover:bg-primary-500 font focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition ease-in-out duration-150"
                >
                  <svg
                    v-if="loading"
                    class="animate-spin -mr-1 ml-3 h-5 w-5 text-yellow-200"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>

                  الاستفسار
                </button>
              </span>
            </div>
          </form>
        </ValidationObserver>
        <div
          class="block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-right overflow-hidden shadow-xl transform transition-all mb-12 m-auto"
          role="dialog"
          v-else
        >
          <div
            v-if="
              result.is_cra_verified == 1 && result.cra_verfication_result  
            "
          >
            <!-- <div
              class="rounded-md bg-green-50 p-4"
             
            >
              <div class="flex" >
                <div class="flex-shrink-0">
                  <svg
                    class="h-5 w-5 text-green-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div class="mr-3">
                  <p class="text-sm font-medium text-green-800">
                    تم تسجيلكم بنجاح
                  </p>
                </div>
              </div>
            </div> -->

            <div
              class="mt-2 text-center sm:mt-2"
              
            >
              <!-- <h3
                class="text-lg font-bold leading-10 text-gray-900"
               
              >
                رقم هاتف المسجل
                <span
                  dir="ltr"
                  class="px-2 inline-flex text-2xl leading-5 font-semibold rounded-full systemfont"
                >
                  {{ result.phone }}
                </span>
              </h3> -->
              <h3
                class="text-lg font-bold leading-10 text-gray-900"
               
              >
             الاسم:
                <span
                  dir="ltr"
                  class="px-2 inline-flex text-2xl leading-5 font-semibold rounded-full systemfont"
                >
                  {{ result.name }}
                </span>
              </h3>
              <h3
                class="text-lg font-bold leading-10 text-gray-900"
                
              >
                المحطة :
                <span
                  class="px-2 inline-flex text-2xl leading-5 font-semibold rounded-full systemfont"
                >
                  {{ result.voting_station }}
                </span>
              </h3>
          
              <h3
                class="text-lg font-bold leading-10 text-gray-900"
                
              >
                المركز الانتخابي :
                <span
                  class="px-2 inline-flex text-2xl leading-5 font-semibold rounded-full systemfont"
                >
                  {{ result.election_center }}
                </span>
              </h3>
              <h3
                class="text-lg font-bold leading-10 text-gray-900"
                
              >
                البلدية :
                <span
                  class="px-2 inline-flex text-2xl leading-5 font-semibold rounded-full systemfont"
                >
                  {{ result.municipality }}
                </span>
              </h3>
             

           
              <h3
                class="text-lg font-bold leading-10 text-gray-900"
               
              >
                الرقم الانتخابي
                <span
                  class="px-2 inline-flex text-2xl leading-5 font-semibold rounded-full systemfont"
                >
                  {{ result.election_code }}
                </span>
              </h3>
              <div class="mt-2">
                <p class="text-lg font-medium leading-7 text-gray-500"></p>
              </div>
            </div>
          </div>
          <div
            v-if="
              result.election_code == null &&
              result.registration_type == 'unregistered_resident' &&  result.is_cra_verified == 1 && result.cra_verfication_result  
            "
          >
            <span>
              <div class="rounded-md bg-yellow-50 p-4">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <svg
                      class="h-5 w-5 text-yellow-400"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div class="mr-3">
                    <h3 class="text-xl font-medium text-yellow-800">
                      لاستكمال عملية التسجيل عليك احضار اثبات اقامة للجنة الفرعية قبل انتهاء المدة المحددة لتسجيل
                    </h3>
                  </div>
                </div>
              </div>
            </span>
          </div>
          <div
            v-else-if="
              result.is_cra_verified == 0 && !result.cra_verfication_result 
            "
          >
            <h3 class="text-2xl font-medium text-yellow-800">
              <div class="rounded-md bg-yellow-50 p-4">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <svg
                      class="h-5 w-5 text-yellow-400"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div class="mr-3">
                    <h3 class="text-2xl font-medium text-yellow-800">
                      معلق للمراجعة
                    </h3>
                  </div>
                </div>
              </div>
            </h3>
          </div>
          <div
            v-else-if="
              result.is_cra_verified == 1 && !result.cra_verfication_result  
            "
          >
            <div class="rounded-md bg-red-50 p-4">
              <div class="flex">
                <div class="flex-shrink-0">
                  <svg
                    class="h-5 w-5 text-red-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div class="mr-3">
                  <h3 class="text-2xl font-medium text-red-800">
                    بيانات غير صحيحة رجاء التأكد من صحة البيانات و اعادة التسجيل
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-6">
            <span class="flex w-full rounded-md shadow-sm">
              <a
               @click="$router.go(0)"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-4 bg-primary-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              >
                عودة 
            </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      success: false,
      loading: false,
      servererrors: null,
      info: {},
      result: {},
    };
  },
  methods: {
    send() {
      console.log(this.info);
      this.loading = true;
      axios.post("/validvoter/check", this.info).then(
        (response) => {
          console.log(response);
          if (response.status == 200) {
            this.success = true;
            this.loading = false;
            this.result = response.data.data;
          } else {
            this.servererrors = response.data.message;
            this.loading = false;
          }
        },
        (error) => {
          this.servererrors = error.response.data.message;
          this.loading = false;
        }
      );
    },
    getStatusClass(status) {
      switch (status) {
        case 0:
          return "bg-orange-100 text-orange-800";

        case 1:
          return "bg-yellow-100 text-yellow-800";

        case 2:
          return "bg-blue-100 text-blue-800";

        case 3:
          return "bg-green-100 text-green-800";

        default:
          return "bg-gray-100 text-gray-800";
      }
    },
    getStatusText(status) {
      switch (status) {
        case 0:
          return "قيد المراجعة";

        case 1:
          return "معلق للمراجعة (مقيم غير مقيد)";

        case 2:
          return "قيد المراجعة";

        case 3:
          return "مسجل بنجاح";

        default:
          return "لم يتم معالجة";
      }
    },
  },
};
</script>
<style scoped>
input[type="number"] {
  -moz-appearance: textfield;
  direction: ltr;
}

input[type="email"] {
  direction: ltr;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.animate-spin {
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>